if (!customElements.get('multitile-popup')) {
  class MultitilePopup extends HTMLElement {
    connectedCallback() {
      this.toggleState = false;

      this.querySelectorAll('[data-popup-close]').forEach(el => {
        el.addEventListener('click', this.close.bind(this));
      });

      this.addEventListener('keydown', e => {
        if (e.key === 'Escape' && this.toggleState) {
          this.close();
        }

        if (this.toggleState && e.key === 'Tab') {
          const focusableElements = this.querySelectorAll(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
          );
          const firstFocusableElement = focusableElements[0];
          const lastFocusableElement = focusableElements[focusableElements.length - 1];

          if (e.shiftKey) {
            if (document.activeElement === firstFocusableElement) {
              e.preventDefault();
              lastFocusableElement.focus();
            }
          } else {
            if (document.activeElement === lastFocusableElement) {
              e.preventDefault();
              firstFocusableElement.focus();
            }
          }
        }
      });
    }

    toggle() {
      if (!this.toggleState) {
        this.open();
      } else {
        this.close();
      }
    }

    open() {
      this.toggleState = true;
      document.querySelector('body').classList.add('overflow-hidden');
      this.classList.add('is--open');
      this.dispatchEvent(new Event('opened', { bubbles: true }));

      // Let the swiper inside recalculate now that it's actually visible
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 50);

      const focusableElement = this.querySelector(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (focusableElement) focusableElement.focus();
    }

    close() {
      this.toggleState = false;
      this.classList.remove('is--open');

      const anyOtherOpen = Array.from(document.querySelectorAll('multitile-popup.is--open')).some(
        el => el !== this
      );
      if (!anyOtherOpen) {
        document.querySelector('body').classList.remove('overflow-hidden');
      }
      this.dispatchEvent(new Event('closed', { bubbles: true }));
    }
  }

  customElements.define('multitile-popup', MultitilePopup);
}